// extracted by mini-css-extract-plugin
export default {"title":"DRI9DC","sub-title":"P17flG","item":"bbkVAD","content":"udYbH3","icon":"Cp8aWh"};